export default "__VITE_ASSET__CuauXpcd__"